import { useReactiveVar } from '@apollo/client'
import { CssBaseline } from '@material-ui/core'
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { credentialsVar } from './cache/auth'
import { darkMode } from './cache/preferences'
import { useBootstrapSession } from './cache/useBootstrapSession'
import PanelLocaleProvider from './components/PanelLocaleProvider'
import { redirectToLogin } from './helpers/sessionRedirect'
import { isTenantHomeViewer } from './helpers/viewerBrand'
import { getDirection, lang } from './localization'
import { configureDateLocale } from './localization/dateLocale'
import Routes from './routes'

configureDateLocale(lang)
function MainRoutes() {
  return (
    <>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
      <ToastContainer
        position={getDirection() === 'rtl' ? 'bottom-left' : 'bottom-right'}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={getDirection() === 'rtl'}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastStyle={{ fontFamily: lang === 'fa' ? 'IRANSans' : 'Nunito' }}
      />
    </>
  )
}
function App() {
  const darktheme = useReactiveVar(darkMode)
  const credentials = useReactiveVar(credentialsVar)
  useBootstrapSession()

  useEffect(() => {
    // Cross-org viewers must never inherit a tenant's visual identity. The
    // BFF derives this type from the verified JWT, not a role/browser value.
    const isTenantHome = isTenantHomeViewer(credentials?.entityType)
    if (credentials && !isTenantHome) {
      document.documentElement.dataset.brand = 'neutral'
      return
    }
    delete document.documentElement.dataset.brand
  }, [credentials])

  useEffect(() => {
    const syncLogout = (event: StorageEvent) => {
      if (event.key === 'logout') {
        redirectToLogin({ skipLogoutEvent: true })
      }
    }

    window.addEventListener('storage', syncLogout)

    return () => {
      window.removeEventListener('storage', syncLogout)
    }
  }, [])

  return (
    <PanelLocaleProvider locale={lang} dark={darktheme}>
      <>
        <CssBaseline />
        <MainRoutes />
      </>
    </PanelLocaleProvider>
  )
}

export default App
